<template>
	<div id="app" data-v="2022092801">
		<router-view></router-view>
	</div>
</template>
<script>
	import {mapGetters, mapActions} from 'vuex';
	export default {
		created(){
			this.pageResize();
		},
		computed: {
			...mapGetters(['app.sizeInfo']),
		},
		mounted(){
			window.onresize=this.pageResize;
		},
		methods:{
			// 页面size
			pageResize(){
				this.pageHeight = window.innerHeight;
				this.pageWidth = window.innerWidth;
				this.$store.dispatch('app/setSizeInfo', {h:this.pageHeight,w:this.pageWidth})
			},
		},beforeDestroy(){
			window.onresize= null;
		},
	};
</script>
<style>
	.el-link-s{
		font-size: 12px!important;
		margin-right: 12px;
		line-height: 1!important;
		position: relative;
		top: -1px;
	}
	#app {
		font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	* {
		padding: 0;
		margin: 0;
	}

	a {
		text-decoration: none;
		color: #177be1;
		cursor: pointer;
	}
	::-webkit-scrollbar{
		height: 12px!important;
	}
	.el-input--mini .el-input__icon {
		line-height: 35px;
	}

	.el-input__inner {
		padding: 0 5px;
	}

	.is_required:before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}

	.router-title {
		font-weight: 600;
		height: 40px;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #36434d;
		font-size: 20px;
		font-weight: 500;
	}

	.router-title i {
		font-size: 36px;
		color: #ff9811;
	}

	/**
	* 去除表格边框线
	*/

	.el-table--border::after {
		top: 0;
		right: 0;
		width: 0px;
		height: 100%;
	}

	.el-table--border .el-table__cell {
		border-right: none;
	}

	.el-table--group,
	.el-table--border {
		border: none;
	}

	/**
	 * Drawer 抽屉
	 */
	.my-el-drawer .el-drawer__body {
		background-color: #f7f9fa;
	}

	.my-el-drawer .el-collapse {
		border: none;
	}

	.my-el-drawer-body {
		padding: 5px;
	}

	.my-descriptions-conten {
		display: flex;
		width: 100%;
		align-items: center;
		border-bottom: 1px solid #e8ebec;
		padding-bottom: 3px;
		text-indent: 3px;
	}

	.my-descriptions-label {
		width: 120px;
		text-align: right
	}

	.el-descriptions-item {
		margin-bottom: 10px;
	}

	.el-divider--vertical {
		width: 5px;
		height: 1.2em;
	}

	.el-divider {
		background-color: #ff9811;
	}

	/**
 * 上传文本框占满
 */
	.upload-demo {
		display: flex;
		flex-direction: column;
	}

	/**
 *  重新设置emelent cart 头部 padding
 */

	.el-card__header {
		padding: 4px 10px 0px 10px;
		border-bottom: none;
	}

	.el-date-editor.el-input {
		width: 100%;
	}

	/* 滚动条 */
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-track {
		background: #fff;
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb {
		background: rgb(205, 206, 206);
		border-radius: 10px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #707375;
	}

	::-webkit-scrollbar-corner {
		background: #fff;
	}

	.el-card__body {
		padding: 5px 10px 10px 10px;
	}

	.el-dialog__header {
		padding: 10px 15px;
		border-radius: 7px 7px 0px 0px;
		border-bottom: 1px solid #f7f7f7;
	}

	.el-dialog {
		border-radius: 7px;
	}

	.el-dialog__body {
		padding: 10px 20px;
	}

	.el-dialog__title {
		color: #333;
		font-size: 16px;
		font-weight: 600;
	}

	.el-dialog__headerbtn {
		font-size: 20px;
	}

	.el-form-item__label {
		padding: 0 6px 0 0;
	}

	/*
	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	.el-dialog__headerbtn .el-dialog__close:hover {
		color: #939393;
	} */

	.el-dialog__headerbtn {
		top: 13px;
	}

	.el-dialog__footer {
		padding: 10px;
		border-top: 1px solid #f7f7f7;
		box-sizing: border-box;
	}

	.app-main {
		color: #333;
		padding: 0px 10px;
	}

	.app-main-header {
		height: 50px;
	}

	.app-main-header-btns {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}

	.home-main {
		background-color: #eaeef0;
	}



	.my-form-item {
		margin-bottom: 0px;
	}

	.mg-b2 {
		margin-bottom: 2px;
	}

	.mg-b5 {
		margin-bottom: 5px;
	}

	.mg-b8 {
		margin-bottom: 8px;
	}

	.mg-b10 {
		margin-bottom: 10px;
	}

	.mg-b15 {
		margin-bottom: 15px;
	}

	.mg-b20 {
		margin-bottom: 20px;
	}

	.mg-t2 {
		margin-top: 2px;
	}

	.mg-t5 {
		margin-top: 5px;
	}

	.mg-t8 {
		margin-top: 8px;
	}

	.mg-t10 {
		margin-top: 10px;
	}

	.mg-t15 {
		margin-top: 15px;
	}
</style>
